
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../Commonlibs/userSlice';
// import {
//   Box,
//   Typography,
//   Button,
//   Pagination,
//   Card,
//   CardContent,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   InputAdornment,
//   Snackbar,
//   Alert,
//   IconButton,
// } from '@mui/material';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import EditIcon from '@mui/icons-material/Edit';
// import ShareIcon from '@mui/icons-material/Share';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import DeleteIcon from '@mui/icons-material/Delete';
// import CloseIcon from '@mui/icons-material/Close';
// import Loader from '../Loader/Loader';

// const outfitFontStyle = {
//   fontFamily: 'Outfit, sans-serif',
// };

// const PropertySeeAll = ({ onEditProperty }) => {
//   const navigate = useNavigate();
//   const [page, setPage] = useState(1);
//   const [loading, setLoading] = useState(true);
//   const [properties, setProperties] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalProperties, setTotalProperties] = useState(0);
//   const user = useSelector(selectUser);

//   const [shareDialog, setShareDialog] = useState(false);
//   const [shareUrl, setShareUrl] = useState('');
//   const [selectedPropertyId, setSelectedPropertyId] = useState(null);

//   // Delete confirmation dialog state
//   const [deleteDialog, setDeleteDialog] = useState(false);
//   const [propertyToDelete, setPropertyToDelete] = useState(null);
//   const [deleting, setDeleting] = useState(false);

//   const [toast, setToast] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });

//   const itemsPerPage = 8;

//   useEffect(() => {
//     fetchProperties();
//   }, [user, page]);

//   const fetchProperties = async () => {
//     setLoading(true);
//     try {
//       const sellerId = user?.id || 2;
//       const response = await fetch(
//         `https://propertydealstalk.com/api/seller/getPropertiesBySellerId?seller_id=${sellerId}&page=${page}&limit=${itemsPerPage}`
//       );
//       const data = await response.json();

//       if (data.status === "SUCCESS" && data.result) {
//         const sortedProperties = (data.result.properties || []).sort((a, b) => {
//           const dateA = new Date(b.updatedAt || b.createdAt);
//           const dateB = new Date(a.updatedAt || a.createdAt);
//           return dateA - dateB;
//         });

//         const processedProperties = sortedProperties.map(property => {
//           const hasImage = hasValidImage(property);
//           return {
//             ...property,
//             hasValidImage: hasImage,
//             processedImageUrl: hasImage ? getPropertyImage(property) : null
//           };
//         });

//         setProperties(processedProperties);
//         setTotalProperties(data.result.total || 0);
//         setTotalPages(data.result.totalPages || 1);
//       } else {
//         setProperties([]);
//       }
//     } catch (error) {
//       console.error('Error fetching properties:', error);
//       setProperties([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const hasValidImage = (property) => {
//     if (property.image && 
//         property.image.length > 100 && 
//         property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
//       return true;
//     }
//     if (property.primary_image && property.primary_image.length > 100) {
//       return true;
//     }
//     if (property.images && typeof property.images === 'string' && property.images.length > 100) {
//       return true;
//     }
//     return false;
//   };

//   const getPropertyImage = (property) => {
//     if (property.image && 
//         property.image.length > 100 && 
//         property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
//       return `data:image/png;base64,${property.image}`;
//     }
//     if (property.primary_image && property.primary_image.length > 100) {
//       return `data:image/jpeg;base64,${property.primary_image}`;
//     }
//     if (property.images && typeof property.images === 'string' && property.images.length > 100) {
//       return property.images.startsWith('data:image') 
//         ? property.images 
//         : `data:image/jpeg;base64,${property.images}`;
//     }
//     return null;
//   };

//   const handleChangePage = (_, newPage) => setPage(newPage);

//   const formatCurrency = (amount, currency = '₹') => {
//     if (!amount) return null;
//     return `${currency}${Number(amount).toLocaleString()}`;
//   };

//   const getTimeAgo = (dateString) => {
//     if (!dateString) return '';
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffInSeconds = Math.floor((now - date) / 1000);
//     const intervals = {
//       y: 31536000, mo: 2592000, w: 604800, d: 86400, h: 3600, m: 60, s: 1
//     };
//     for (const [key, value] of Object.entries(intervals)) {
//       const interval = Math.floor(diffInSeconds / value);
//       if (interval >= 1) return `${interval}${key} ago`;
//     }
//     return 'just now';
//   };

//   const getStatusClass = (status) => {
//     switch(status?.toLowerCase()) {
//       case 'active':
//       case 'approved': return '#10b981';
//       case 'under_verification':
//       case 'pending': return '#f59e0b';
//       case 'rejected':
//       case 'declined': return '#ef4444';
//       case 'inactive':
//       case 'expired': return '#6b7280';
//       default: return 'rgba(0,0,0,0.7)';
//     }
//   };

//   const getStatusText = (status) => {
//     if (!status) return 'Unknown';
//     const statusMap = {
//       'active': 'Active',
//       'approved': 'Approved',
//       'under_verification': 'Under Verification',
//       'pending': 'Pending',
//       'rejected': 'Rejected',
//       'declined': 'Declined',
//       'inactive': 'Inactive',
//       'expired': 'Expired'
//     };
//     return statusMap[status.toLowerCase()] || status.charAt(0).toUpperCase() + status.slice(1);
//   };

//   const handleViewProperty = (propertyId) => {
//     navigate(`/view/${propertyId}`);
//   };

//   // Delete handlers
//   const handleDeleteClick = (property) => {
//     setPropertyToDelete(property);
//     setDeleteDialog(true);
//   };

//   const handleCloseDeleteDialog = () => {
//     setDeleteDialog(false);
//     setPropertyToDelete(null);
//   };

//   const handleConfirmDelete = async () => {
//     if (!propertyToDelete) return;
    
//     setDeleting(true);
//     try {
//       const response = await fetch('https://propertydealstalk.com/api/property/deleteProperty', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           property_id: propertyToDelete.id.toString(),
//           user_id: user?.id?.toString() || "10",
//           role: "seller"
//         }),
//       });

//       const data = await response.json();

//       if (data.status === 'SUCCESS') {
//         setToast({
//           open: true,
//           message: 'Property deleted successfully!',
//           severity: 'success'
//         });
//         setDeleteDialog(false);
//         setPropertyToDelete(null);
        
//         // Refresh properties list
//         fetchProperties();
//       } else {
//         setToast({
//           open: true,
//           message: data.message || 'Failed to delete property',
//           severity: 'error'
//         });
//       }
//     } catch (error) {
//       console.error('Error deleting property:', error);
//       setToast({
//         open: true,
//         message: 'An error occurred while deleting the property',
//         severity: 'error'
//       });
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const handleShareClick = async (propertyId) => {
//     const property = properties.find(p => p.id === propertyId);
//     const publicUrl = `${window.location.origin}/view/${propertyId}`;
    
//     const shareData = {
//       title: property?.property_name || 'Property on PropertyDealsTalk',
//       text: `Check out ${property?.property_name || 'this property'} - ${
//         property?.category === 'sale'
//           ? formatCurrency(property?.asking_price, property?.currency)
//           : `${formatCurrency(property?.monthly_rent, property?.currency)}/month`
//       } at ${property?.location || 'prime location'}`,
//       url: publicUrl
//     };

//     if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
//       try {
//         await navigator.share(shareData);
//         setToast({
//           open: true,
//           message: 'Shared successfully!',
//           severity: 'success'
//         });
//       } catch (err) {
//         if (err.name !== 'AbortError') {
//           setShareUrl(publicUrl);
//           setSelectedPropertyId(propertyId);
//           setShareDialog(true);
//         }
//       }
//     } else {
//       setShareUrl(publicUrl);
//       setSelectedPropertyId(propertyId);
//       setShareDialog(true);
//     }
//   };

//   const handleCopyUrl = async () => {
//     try {
//       await navigator.clipboard.writeText(shareUrl);
//       setToast({
//         open: true,
//         message: 'Link copied to clipboard!',
//         severity: 'success'
//       });
//     } catch (err) {
//       setToast({
//         open: true,
//         message: 'Failed to copy link',
//         severity: 'error'
//       });
//     }
//   };

//   const handleCloseShareDialog = () => {
//     setShareDialog(false);
//     setSelectedPropertyId(null);
//   };

//   const handleCloseToast = (event, reason) => {
//     if (reason === 'clickaway') return;
//     setToast(prev => ({ ...prev, open: false }));
//   };

//   if (loading) return <Loader />;

//   return (
//     <Box
//       sx={{
//         mt: '0px',
//         mb: { xs: '100px', md: '140px' },
//         mx: 'auto',
//         px: { xs: 2, md: 2 },
//         width: '100%',
//         maxWidth: '1100px',
//         border: '2px solid #f1f1f1',
//         borderRadius: '16px',
//         background: '#fff',
//         boxSizing: 'border-box',
//         py: { xs: 4, md: 6 },
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           mb: 4,
//           px: { xs: 1, md: 2 },
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{ ...outfitFontStyle, fontWeight: 600, color: '#111827' }}
//         >
//           My Properties ({totalProperties})
//         </Typography>
//       </Box>

//       {properties.length === 0 ? (
//         <Box sx={{ textAlign: 'center', py: 8 }}>
//           <Typography variant="h6" color="#666" sx={outfitFontStyle}>
//             No properties found
//           </Typography>
//           <Typography variant="body2" color="#999" sx={{ mt: 1, ...outfitFontStyle }}>
//             Start by adding your first property
//           </Typography>
//         </Box>
//       ) : (
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, px: 1 }}>
//           {properties.map((property) => {
//             const timeAgo = getTimeAgo(property.updatedAt || property.createdAt);
            
//             return (
//               <Box
//                 key={property.id}
//                 sx={{
//                   width: { xs: '100%', sm: 'calc(50% - 12px)', md: 'calc(33.333% - 16px)' },
//                   mb: 1
//                 }}
//               >
//                 <Card
//                   sx={{
//                     borderRadius: '12px',
//                     overflow: 'hidden',
//                     boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//                     height: '100%',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     position: 'relative',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
//                       transform: 'translateY(-2px)',
//                     },
//                   }}
//                 >
//                   {property.status && (
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         top: 10,
//                         right: 10,
//                         backgroundColor: getStatusClass(property.status),
//                         color: 'white',
//                         padding: '4px 10px',
//                         borderRadius: '4px',
//                         fontSize: '10px',
//                         fontWeight: 500,
//                         zIndex: 2,
//                         ...outfitFontStyle,
//                       }}
//                     >
//                       {getStatusText(property.status)}
//                     </Box>
//                   )}

//                   <Box sx={{ position: 'relative', width: '100%', height: '180px' }}>
//                     {property.hasValidImage ? (
//                       <Box
//                         component="img"
//                         src={property.processedImageUrl}
//                         alt={property.property_name || "Property"}
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           objectFit: 'cover',
//                           backgroundColor: '#f5f5f5'
//                         }}
//                       />
//                     ) : (
//                       <Box
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backgroundColor: '#f5f5f5',
//                           border: '1px dashed #ccc'
//                         }}
//                       >
//                         <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                           No images uploaded
//                         </Typography>
//                       </Box>
//                     )}

//                     {timeAgo && (
//                       <Box
//                         sx={{
//                           position: 'absolute',
//                           bottom: '8px',
//                           left: '8px',
//                           bgcolor: 'rgba(0, 0, 0, 0.7)',
//                           color: '#fff',
//                           px: '8px',
//                           py: '4px',
//                           borderRadius: '4px',
//                           fontSize: '11px',
//                           fontWeight: 500,
//                           zIndex: 1,
//                           ...outfitFontStyle,
//                         }}
//                       >
//                         {timeAgo}
//                       </Box>
//                     )}
//                   </Box>

//                   <CardContent
//                     sx={{
//                       p: 2,
//                       flexGrow: 1,
//                       display: 'flex',
//                       flexDirection: 'column',
//                       justifyContent: 'space-between',
//                     }}
//                   >
//                     <Box>
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'flex-start',
//                           mb: 1,
//                           gap: 1,
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           sx={{
//                             ...outfitFontStyle,
//                             fontWeight: 600,
//                             fontSize: '16px',
//                             mb: 0.5,
//                             flex: 1,
//                             lineHeight: 1.3,
//                           }}
//                         >
//                           {property.property_name || "Unnamed Property"}
//                         </Typography>
//                         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
//                           <Button
//                             size="small"
//                             startIcon={<EditIcon sx={{ fontSize: 14 }} />}
//                             onClick={() => navigate(`/sell-properties/edit/${property.id}`)}
//                             sx={{
//                               minWidth: 'auto',
//                               px: 1,
//                               py: 0.5,
//                               color: '#3b82f6',
//                               fontSize: '12px',
//                               textTransform: 'none',
//                               '&:hover': {
//                                 backgroundColor: 'rgba(59, 130, 246, 0.08)',
//                               },
//                               ...outfitFontStyle,
//                             }}
//                           >
//                             Edit
//                           </Button>
//                           <Button
//                             size="small"
//                             startIcon={<DeleteIcon sx={{ fontSize: 14 }} />}
//                             onClick={() => handleDeleteClick(property)}
//                             sx={{
//                               minWidth: 'auto',
//                               px: 1,
//                               py: 0.5,
//                               color: '#ef4444',
//                               fontSize: '12px',
//                               textTransform: 'none',
//                               '&:hover': {
//                                 backgroundColor: 'rgba(239, 68, 68, 0.08)',
//                               },
//                               ...outfitFontStyle,
//                             }}
//                           >
//                             Delete
//                           </Button>
//                         </Box>
//                       </Box>

//                       <Typography
//                         variant="h6"
//                         sx={{
//                           ...outfitFontStyle,
//                           fontWeight: 700,
//                           color: '#3b82f6',
//                           mb: 1,
//                           fontSize: '18px',
//                         }}
//                       >
//                         {property.category === 'sale'
//                           ? formatCurrency(property.asking_price, property.currency)
//                           : `${formatCurrency(property.monthly_rent, property.currency)}/month`}
//                       </Typography>

//                       <Typography
//                         variant="body2"
//                         sx={{
//                           ...outfitFontStyle,
//                           color: '#6b7280',
//                           fontSize: '14px',
//                           mb: 2,
//                           lineHeight: 1.4,
//                         }}
//                       >
//                         {property.area_name || ""}, {property.location || ""}
//                       </Typography>
//                     </Box>

//                     <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
//                       <Button
//                         fullWidth
//                         variant="contained"
//                         startIcon={<VisibilityIcon />}
//                         onClick={() => handleViewProperty(property.id)}
//                         sx={{
//                           ...outfitFontStyle,
//                           textTransform: 'none',
//                           fontSize: '13px',
//                           fontWeight: 500,
//                           py: 0.75,
//                           backgroundColor: '#3b82f6',
//                           '&:hover': { backgroundColor: '#2563eb' },
//                         }}
//                       >
//                         View
//                       </Button>
//                       <Button
//                         fullWidth
//                         variant="outlined"
//                         startIcon={<ShareIcon />}
//                         onClick={() => handleShareClick(property.id)}
//                         sx={{
//                           ...outfitFontStyle,
//                           textTransform: 'none',
//                           fontSize: '13px',
//                           fontWeight: 500,
//                           py: 0.75,
//                           borderColor: '#3b82f6',
//                           color: '#3b82f6',
//                           '&:hover': {
//                             borderColor: '#2563eb',
//                             backgroundColor: 'rgba(59, 130, 246, 0.04)',
//                           },
//                         }}
//                       >
//                         Share
//                       </Button>
//                     </Box>

//                     <Box
//                       sx={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         pt: 1,
//                         borderTop: '1px solid #f3f4f6',
//                       }}
//                     >
//                       <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <VisibilityIcon sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }} />
//                         <Typography
//                           variant="caption"
//                           sx={{
//                             ...outfitFontStyle,
//                             color: '#6b7280',
//                             fontSize: '12px',
//                             fontWeight: 500,
//                           }}
//                         >
//                           0 Views
//                         </Typography>
//                       </Box>
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           ...outfitFontStyle,
//                           color: '#9ca3af',
//                           fontSize: '11px',
//                         }}
//                       >
//                         Property ID: #PD{property.id.toString().padStart(6, '0')}
//                       </Typography>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               </Box>
//             );
//           })}
//         </Box>
//       )}

//       {totalPages > 1 && (
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6, pr: { xs: 2, md: 4 } }}>
//           <Pagination
//             count={totalPages}
//             page={page}
//             onChange={handleChangePage}
//             color="primary"
//             size="large"
//             sx={{ '& .MuiPaginationItem-root': { ...outfitFontStyle, fontWeight: 500 } }}
//           />
//         </Box>
//       )}

//       {/* Delete Confirmation Dialog */}
//       <Dialog 
//         open={deleteDialog} 
//         onClose={handleCloseDeleteDialog}
//         maxWidth="xs" 
//         fullWidth
//       >
//         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="h6" fontWeight={600} sx={outfitFontStyle}>
//             Delete Property
//           </Typography>
//           <IconButton onClick={handleCloseDeleteDialog} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body1" sx={{ ...outfitFontStyle, mb: 2 }}>
//             Are you sure you want to delete this property?
//           </Typography>
//           {propertyToDelete && (
//             <Typography variant="body2" color="#666" sx={outfitFontStyle}>
//               <strong>{propertyToDelete.property_name || 'Unnamed Property'}</strong>
//             </Typography>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
//           <Button 
//             onClick={handleCloseDeleteDialog} 
//             variant="outlined" 
//             sx={outfitFontStyle}
//             disabled={deleting}
//           >
//             No
//           </Button>
//           <Button 
//             onClick={handleConfirmDelete} 
//             variant="contained" 
//             color="error"
//             sx={outfitFontStyle}
//             disabled={deleting}
//           >
//             {deleting ? 'Deleting...' : 'Yes, Delete'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Share Dialog */}
//       <Dialog open={shareDialog} onClose={handleCloseShareDialog} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Typography variant="h6" fontWeight={600} sx={outfitFontStyle}>
//             Share Property
//           </Typography>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="#666" mb={2} sx={outfitFontStyle}>
//             Copy and share this property link
//           </Typography>
//           <TextField
//             fullWidth
//             value={shareUrl}
//             InputProps={{
//               readOnly: true,
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={handleCopyUrl} edge="end" color="primary">
//                     <ContentCopyIcon />
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//             sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#f5f5f5', ...outfitFontStyle } }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={handleCloseShareDialog} variant="outlined" sx={outfitFontStyle}>
//             Close
//           </Button>
//           <Button onClick={handleCopyUrl} variant="contained" startIcon={<ContentCopyIcon />} sx={outfitFontStyle}>
//             Copy Link
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Toast Notifications */}
//       <Snackbar
//         open={toast.open}
//         autoHideDuration={4000}
//         onClose={handleCloseToast}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%', ...outfitFontStyle }}>
//           {toast.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default PropertySeeAll;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../Commonlibs/userSlice';
import {
  Box,
  Typography,
  Button,
  Pagination,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Snackbar,
  Alert,
  IconButton,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '../Loader/Loader';

const outfitFontStyle = {
  fontFamily: 'Outfit, sans-serif',
};

const PropertySeeAll = ({ onEditProperty }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [properties, setProperties] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalProperties, setTotalProperties] = useState(0);
  const [statusFilter, setStatusFilter] = useState('all');
  const user = useSelector(selectUser);

  const [shareDialog, setShareDialog] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);

  // Delete confirmation dialog state
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const itemsPerPage = 8;

  useEffect(() => {
    fetchProperties();
  }, [user, page, statusFilter]);

  const fetchProperties = async () => {
    setLoading(true);
    try {
      const sellerId = user?.id || 2;
      let url = `https://propertydealstalk.com/api/seller/getPropertiesBySellerId?seller_id=${sellerId}&page=${page}&limit=${itemsPerPage}`;
      
      // Add status filter if not 'all'
      if (statusFilter !== 'all') {
        url += `&status=${statusFilter}`;
      }
      
      const response = await fetch(url);
      const data = await response.json();

      if (data.status === "SUCCESS" && data.result) {
        const sortedProperties = (data.result.properties || []).sort((a, b) => {
          const dateA = new Date(b.updatedAt || b.createdAt);
          const dateB = new Date(a.updatedAt || a.createdAt);
          return dateA - dateB;
        });

        const processedProperties = sortedProperties.map(property => {
          const hasImage = hasValidImage(property);
          return {
            ...property,
            hasValidImage: hasImage,
            processedImageUrl: hasImage ? getPropertyImage(property) : null
          };
        });

        setProperties(processedProperties);
        setTotalProperties(data.result.total || 0);
        setTotalPages(data.result.totalPages || 1);
      } else {
        setProperties([]);
      }
    } catch (error) {
      console.error('Error fetching properties:', error);
      setProperties([]);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(1); // Reset to first page when filter changes
  };

  const hasValidImage = (property) => {
    if (property.image && 
        property.image.length > 100 && 
        property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
      return true;
    }
    if (property.primary_image && property.primary_image.length > 100) {
      return true;
    }
    if (property.images && typeof property.images === 'string' && property.images.length > 100) {
      return true;
    }
    return false;
  };

  const getPropertyImage = (property) => {
    if (property.image && 
        property.image.length > 100 && 
        property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
      return `data:image/png;base64,${property.image}`;
    }
    if (property.primary_image && property.primary_image.length > 100) {
      return `data:image/jpeg;base64,${property.primary_image}`;
    }
    if (property.images && typeof property.images === 'string' && property.images.length > 100) {
      return property.images.startsWith('data:image') 
        ? property.images 
        : `data:image/jpeg;base64,${property.images}`;
    }
    return null;
  };

  const handleChangePage = (_, newPage) => setPage(newPage);

  const formatCurrency = (amount, currency = '₹') => {
    if (!amount) return null;
    return `${currency}${Number(amount).toLocaleString()}`;
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    const intervals = {
      y: 31536000, mo: 2592000, w: 604800, d: 86400, h: 3600, m: 60, s: 1
    };
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) return `${interval}${key} ago`;
    }
    return 'just now';
  };

  const getStatusClass = (status) => {
    switch(status?.toLowerCase()) {
      case 'active':
      case 'approved': return '#10b981';
      case 'under_verification':
      case 'pending': return '#f59e0b';
      case 'rejected':
      case 'declined': return '#ef4444';
      case 'inactive':
      case 'expired': return '#6b7280';
      default: return 'rgba(0,0,0,0.7)';
    }
  };

  const getStatusText = (status) => {
    if (!status) return 'Unknown';
    const statusMap = {
      'active': 'Active',
      'approved': 'Approved',
      'under_verification': 'Under Verification',
      'pending': 'Pending',
      'rejected': 'Rejected',
      'declined': 'Declined',
      'inactive': 'Inactive',
      'expired': 'Expired'
    };
    return statusMap[status.toLowerCase()] || status.charAt(0).toUpperCase() + status.slice(1);
  };

  const handleViewProperty = (propertyId) => {
    navigate(`/view/${propertyId}`);
  };

  // Delete handlers
  const handleDeleteClick = (property) => {
    setPropertyToDelete(property);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialog(false);
    setPropertyToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (!propertyToDelete) return;
    
    setDeleting(true);
    try {
      const response = await fetch('https://propertydealstalk.com/api/property/deleteProperty', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          property_id: propertyToDelete.id.toString(),
          user_id: user?.id?.toString() || "10",
          role: "seller"
        }),
      });

      const data = await response.json();

      if (data.status === 'SUCCESS') {
        setToast({
          open: true,
          message: 'Property deleted successfully!',
          severity: 'success'
        });
        setDeleteDialog(false);
        setPropertyToDelete(null);
        
        // Refresh properties list
        fetchProperties();
      } else {
        setToast({
          open: true,
          message: data.message || 'Failed to delete property',
          severity: 'error'
        });
      }
    } catch (error) {
      console.error('Error deleting property:', error);
      setToast({
        open: true,
        message: 'An error occurred while deleting the property',
        severity: 'error'
      });
    } finally {
      setDeleting(false);
    }
  };

  const handleShareClick = async (propertyId) => {
    const property = properties.find(p => p.id === propertyId);
    const publicUrl = `${window.location.origin}/view/${propertyId}`;
    
    const shareData = {
      title: property?.property_name || 'Property on PropertyDealsTalk',
      text: `Check out ${property?.property_name || 'this property'} - ${
        property?.category === 'sale'
          ? formatCurrency(property?.asking_price, property?.currency)
          : `${formatCurrency(property?.monthly_rent, property?.currency)}/month`
      } at ${property?.location || 'prime location'}`,
      url: publicUrl
    };

    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData);
        setToast({
          open: true,
          message: 'Shared successfully!',
          severity: 'success'
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          setShareUrl(publicUrl);
          setSelectedPropertyId(propertyId);
          setShareDialog(true);
        }
      }
    } else {
      setShareUrl(publicUrl);
      setSelectedPropertyId(propertyId);
      setShareDialog(true);
    }
  };

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setToast({
        open: true,
        message: 'Link copied to clipboard!',
        severity: 'success'
      });
    } catch (err) {
      setToast({
        open: true,
        message: 'Failed to copy link',
        severity: 'error'
      });
    }
  };

  const handleCloseShareDialog = () => {
    setShareDialog(false);
    setSelectedPropertyId(null);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setToast(prev => ({ ...prev, open: false }));
  };

  if (loading) return <Loader />;

  return (
    <Box
      sx={{
        mt: '0px',
        mb: { xs: '100px', md: '140px' },
        mx: 'auto',
        px: { xs: 2, md: 2 },
        width: '100%',
        maxWidth: '1100px',
        border: '2px solid #f1f1f1',
        borderRadius: '16px',
        background: '#fff',
        boxSizing: 'border-box',
        py: { xs: 4, md: 6 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 4,
          px: { xs: 1, md: 2 },
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{ ...outfitFontStyle, fontWeight: 600, color: '#111827' }}
        >
          My Properties ({totalProperties})
        </Typography>

        {/* Status Filter Dropdown */}
        <FormControl 
          size="small" 
          sx={{ 
            minWidth: 200,
            '& .MuiOutlinedInput-root': {
              ...outfitFontStyle,
            }
          }}
        >
          <Select
            value={statusFilter}
            onChange={handleStatusChange}
            displayEmpty
            sx={{
              ...outfitFontStyle,
              fontSize: '14px',
              fontWeight: 500,
              '& .MuiSelect-select': {
                py: 1,
              }
            }}
          >
            <MenuItem value="all" sx={outfitFontStyle}>All Properties</MenuItem>
            <MenuItem value="approved" sx={outfitFontStyle}>Approved</MenuItem>
            <MenuItem value="rejected" sx={outfitFontStyle}>Rejected</MenuItem>
            <MenuItem value="under_verification" sx={outfitFontStyle}>Under Verification</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {properties.length === 0 ? (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="#666" sx={outfitFontStyle}>
            No properties found
          </Typography>
          <Typography variant="body2" color="#999" sx={{ mt: 1, ...outfitFontStyle }}>
            {statusFilter !== 'all' 
              ? `No properties with status: ${getStatusText(statusFilter)}`
              : 'Start by adding your first property'}
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, px: 1 }}>
          {properties.map((property) => {
            const timeAgo = getTimeAgo(property.updatedAt || property.createdAt);
            
            return (
              <Box
                key={property.id}
                sx={{
                  width: { xs: '100%', sm: 'calc(50% - 12px)', md: 'calc(33.333% - 16px)' },
                  mb: 1
                }}
              >
                <Card
                  sx={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                      transform: 'translateY(-2px)',
                    },
                  }}
                >
                  {property.status && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        backgroundColor: getStatusClass(property.status),
                        color: 'white',
                        padding: '4px 10px',
                        borderRadius: '4px',
                        fontSize: '10px',
                        fontWeight: 500,
                        zIndex: 2,
                        ...outfitFontStyle,
                      }}
                    >
                      {getStatusText(property.status)}
                    </Box>
                  )}

                  <Box sx={{ position: 'relative', width: '100%', height: '180px' }}>
                    {property.hasValidImage ? (
                      <Box
                        component="img"
                        src={property.processedImageUrl}
                        alt={property.property_name || "Property"}
                        sx={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          backgroundColor: '#f5f5f5'
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          border: '1px dashed #ccc'
                        }}
                      >
                        <Typography variant="body2" color="#888" textAlign="center" px={2}>
                          No images uploaded
                        </Typography>
                      </Box>
                    )}

                    {timeAgo && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: '8px',
                          left: '8px',
                          bgcolor: 'rgba(0, 0, 0, 0.7)',
                          color: '#fff',
                          px: '8px',
                          py: '4px',
                          borderRadius: '4px',
                          fontSize: '11px',
                          fontWeight: 500,
                          zIndex: 1,
                          ...outfitFontStyle,
                        }}
                      >
                        {timeAgo}
                      </Box>
                    )}
                  </Box>

                  <CardContent
                    sx={{
                      p: 2,
                      flexGrow: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          mb: 1,
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            ...outfitFontStyle,
                            fontWeight: 600,
                            fontSize: '16px',
                            mb: 0.5,
                            flex: 1,
                            lineHeight: 1.3,
                          }}
                        >
                          {property.property_name || "Unnamed Property"}
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          <Button
                            size="small"
                            startIcon={<EditIcon sx={{ fontSize: 14 }} />}
                            onClick={() => navigate(`/sell-properties/edit/${property.id}`)}
                            sx={{
                              minWidth: 'auto',
                              px: 1,
                              py: 0.5,
                              color: '#3b82f6',
                              fontSize: '12px',
                              textTransform: 'none',
                              '&:hover': {
                                backgroundColor: 'rgba(59, 130, 246, 0.08)',
                              },
                              ...outfitFontStyle,
                            }}
                          >
                            Edit
                          </Button>
                          <Button
                            size="small"
                            startIcon={<DeleteIcon sx={{ fontSize: 14 }} />}
                            onClick={() => handleDeleteClick(property)}
                            sx={{
                              minWidth: 'auto',
                              px: 1,
                              py: 0.5,
                              color: '#ef4444',
                              fontSize: '12px',
                              textTransform: 'none',
                              '&:hover': {
                                backgroundColor: 'rgba(239, 68, 68, 0.08)',
                              },
                              ...outfitFontStyle,
                            }}
                          >
                            Delete
                          </Button>
                        </Box>
                      </Box>

                      <Typography
                        variant="h6"
                        sx={{
                          ...outfitFontStyle,
                          fontWeight: 700,
                          color: '#3b82f6',
                          mb: 1,
                          fontSize: '18px',
                        }}
                      >
                        {property.category === 'sale'
                          ? formatCurrency(property.asking_price, property.currency)
                          : `${formatCurrency(property.monthly_rent, property.currency)}/month`}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          ...outfitFontStyle,
                          color: '#6b7280',
                          fontSize: '14px',
                          mb: 2,
                          lineHeight: 1.4,
                        }}
                      >
                        {property.area_name || ""}, {property.location || ""}
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                      <Button
                        fullWidth
                        variant="contained"
                        startIcon={<VisibilityIcon />}
                        onClick={() => handleViewProperty(property.id)}
                        sx={{
                          ...outfitFontStyle,
                          textTransform: 'none',
                          fontSize: '13px',
                          fontWeight: 500,
                          py: 0.75,
                          backgroundColor: '#3b82f6',
                          '&:hover': { backgroundColor: '#2563eb' },
                        }}
                      >
                        View
                      </Button>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<ShareIcon />}
                        onClick={() => handleShareClick(property.id)}
                        sx={{
                          ...outfitFontStyle,
                          textTransform: 'none',
                          fontSize: '13px',
                          fontWeight: 500,
                          py: 0.75,
                          borderColor: '#3b82f6',
                          color: '#3b82f6',
                          '&:hover': {
                            borderColor: '#2563eb',
                            backgroundColor: 'rgba(59, 130, 246, 0.04)',
                          },
                        }}
                      >
                        Share
                      </Button>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pt: 1,
                        borderTop: '1px solid #f3f4f6',
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <VisibilityIcon sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }} />
                        <Typography
                          variant="caption"
                          sx={{
                            ...outfitFontStyle,
                            color: '#6b7280',
                            fontSize: '12px',
                            fontWeight: 500,
                          }}
                        >
                          0 Views
                        </Typography>
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          ...outfitFontStyle,
                          color: '#9ca3af',
                          fontSize: '11px',
                        }}
                      >
                        Property ID: #PD{property.id.toString().padStart(6, '0')}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            );
          })}
        </Box>
      )}

      {totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6, pr: { xs: 2, md: 4 } }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}
            color="primary"
            size="large"
            sx={{ '& .MuiPaginationItem-root': { ...outfitFontStyle, fontWeight: 500 } }}
          />
        </Box>
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog 
        open={deleteDialog} 
        onClose={handleCloseDeleteDialog}
        maxWidth="xs" 
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600} sx={outfitFontStyle}>
            Delete Property
          </Typography>
          <IconButton onClick={handleCloseDeleteDialog} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ ...outfitFontStyle, mb: 2 }}>
            Are you sure you want to delete this property?
          </Typography>
          {propertyToDelete && (
            <Typography variant="body2" color="#666" sx={outfitFontStyle}>
              <strong>{propertyToDelete.property_name || 'Unnamed Property'}</strong>
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button 
            onClick={handleCloseDeleteDialog} 
            variant="outlined" 
            sx={outfitFontStyle}
            disabled={deleting}
          >
            No
          </Button>
          <Button 
            onClick={handleConfirmDelete} 
            variant="contained" 
            color="error"
            sx={outfitFontStyle}
            disabled={deleting}
          >
            {deleting ? 'Deleting...' : 'Yes, Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Share Dialog */}
      <Dialog open={shareDialog} onClose={handleCloseShareDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight={600} sx={outfitFontStyle}>
            Share Property
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="#666" mb={2} sx={outfitFontStyle}>
            Copy and share this property link
          </Typography>
          <TextField
            fullWidth
            value={shareUrl}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleCopyUrl} edge="end" color="primary">
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#f5f5f5', ...outfitFontStyle } }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseShareDialog} variant="outlined" sx={outfitFontStyle}>
            Close
          </Button>
          <Button onClick={handleCopyUrl} variant="contained" startIcon={<ContentCopyIcon />} sx={outfitFontStyle}>
            Copy Link
          </Button>
        </DialogActions>
      </Dialog>

      {/* Toast Notifications */}
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%', ...outfitFontStyle }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PropertySeeAll;

